export default __webpack_public_path__ + "static/media/Diamant.03f4792b.png";